export const Page = {
    landing: 'landing',
    profile: 'profile',
    leaderboards: 'leaderboards',
    home: 'home',
    tasks: 'tasks',
    journal: 'journal',
}
